export type ApiMode = 'mock' | 'live';
/** VITE_API_MODE=mock (opt-in) serves the API in-browser; live goes through the Vite /api proxy to core-api. */
export const API_MODE: ApiMode = (import.meta.env.VITE_API_MODE as ApiMode) === 'mock' ? 'mock' : 'live';
